// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3H_cB","rootCenter":"LoadMoreObserver_rootCenter__Wbf9a","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2lEtc"};